import OtherOptionsSidebar from "./OtherOptionsSidebar";

const DonateDetailsSidebar = () => {
  return (
    <div className="offcanvas-collapse d-none d-lg-block">
      <OtherOptionsSidebar />
    </div>
  );
};

export default DonateDetailsSidebar;
